import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css';
// import './assets/css/fonts-google.css'
import './assets/css/bootstrap.css'
import './assets/css/bootstrap-extended.css'
import './assets/css/components.css'
import './assets/css/colors.css'
import './assets/css/vertical-menu.css'
import './assets/css/style.css'

import { LoginPage } from './pages/login/login.component'
import { HomePage } from './pages/home/home.component'
import { Feeds } from './layout/feeds/feed.component';
import { IdeaForm } from './components/ideaForm/ideaForm.component';
import { ProtectedComponent } from './components/protectedComponent/protectedComponent.component';
import { useDispatch, useSelector } from 'react-redux';
import { AdminHomePage } from './pages/adminHome/adminHome.component';
import { AdminDashBoard } from './components/adminDashboard/adminDashboard.component';
import { HomeRoutes } from './routes/homeRoutes/homeRoutes.components';
import { AdminRoutes } from './routes/adminRoutes/adminRoutes.components';
import { loginUser, logout, refreshToken } from './services/login.service';
import { userActions } from './store/user';

import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { ModeratorAndJuryRoutes } from './routes/moderatorRoutes/moderatorRoutes.components';
import { PageLoading } from './components/pageLoading/pageLoading.component';
import { useMemo } from 'react';
import Page404 from './components/404/page404.component';
import { showError, showInfo } from './utils/alertsUtils';

const App = ({ msalInstance }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const dispatch = useDispatch()
  const { instance, accounts, inProgress } = useMsal()
  // const isAuth = useSelector(state => state.auth.isLoggedIn)
  const isAuth = useSelector(state => state.user.isAuth)
  const { empType, token } = useSelector(state => state.user)

  const persistLogin = async () => {
    const token = sessionStorage.getItem('auth')
    if (token && token !== 'undefined') {
      // const payload = token.split('.')[1];
      // const decodedPayload = JSON.parse(atob(payload));
      // console.log(decodedPayload);
      // dispatch(userActions.login(decodedPayload))
      // const refresh = await refreshToken(token)
      // if (refresh.status === 200) {
      //   dispatch(userActions.login(refresh.data))
      // }
      await login(token)
    }
    else if (accounts.length) {
      const account = accounts[0];
      const response = await instance.acquireTokenSilent({
        scopes: ['user.read'],  // Define the required scopes
        account: account,
      });
      await login(response.accessToken)

    }
    setTimeout(() => {
      setIsLoaded(true)
    }, 400)
  }

  const login = async (token) => {

    const login = await loginUser(token)
    const response = login.data
    if (login.status !== 200) {
      showError('Something Went Wrong!');
    } else if (response.error) {
      showError(response.error);
    }
    else {
      if (response.activeSession) {
        showInfo('You had an active session!');
      }
      setTimeout(() => {
        dispatch(userActions.login(response));
      }, 3000)
    }



  }
  // const login = async () => {
  //   const accountInfo = accounts[0] || null
  //   console.log(accountInfo)
  //   if(accountInfo) {
  //     const login = await loginUser(accountInfo)
  //     const response = login.data
  //     dispatch(userActions.login(response))
  //   }
  // }

  // useMemo(() => {
  //   login()
  // }, [accounts])

  useEffect(() => {
    if (window !== window.top) {
      window.top.location = window.location;
    }
    persistLogin();
  }, [accounts])


  return (

    isLoaded ? (isAuth
      ? empType === 101
        ? <AdminRoutes />
        : empType === 152 || empType === 171
          ? <ModeratorAndJuryRoutes />
          : <HomeRoutes />
      : <Routes>
        <Route path='/' element={<LoginPage />} />
        <Route path='*' element={<Page404 />} />
      </Routes>) : <PageLoading />
  )
}

export default App
